module.exports = __webpack_public_path__ + "static/media/400006_01.5a18b25a.png";